import type { FC } from 'react';
import { STATUS_COLORS, STATUS_LABELS } from '../constants/orderStatuses';

interface StatusBadgeProps {
    status: string;
    className?: string;
    colorMap?: Record<string, string>;
    labelMap?: Record<string, string>;
}

const StatusBadge: FC<StatusBadgeProps> = ({ status, className = '', colorMap, labelMap }) => {
    const key    = status?.toUpperCase() ?? '';
    const colors = (colorMap ?? STATUS_COLORS)[key]  ?? 'bg-stone-100 text-stone-700 ring-stone-200';
    const label  = (labelMap ?? STATUS_LABELS)[key]  ?? key.replace(/_/g, ' ').toLowerCase();
    return (
        <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset capitalize ${colors} ${className}`}>
            {label}
        </span>
    );
};

export default StatusBadge;